export default (items: string): string[] => {
  if (items === undefined || items === null) {
    return null;
  }

  if (!items) {
    return [];
  }

  return items.split(',')
    .filter(item => !!item)
    .map(item => item);
};
